import { AbstractControl, ValidationErrors } from '@angular/forms';

export function passwordComplexityValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value ?? '';
  if (!value) return null;

  const errors: ValidationErrors = {};

  if (value.length < 8) errors.minLength = true;
  if (!/^\S+$/.test(value)) errors.containsSpaces = true;
  if (!/(?=.*[A-Z])/.test(value)) errors.missingUppercase = true;
  if (!/(?=.*[a-z])/.test(value)) errors.missingLowercase = true;
  if (!/(?=.*\d)/.test(value)) errors.missingNumber = true;
  if (!/[^A-Za-z0-9]/.test(value)) errors.missingSpecialCharacter = true;

  return Object.keys(errors).length ? { passwordComplexity: errors } : null;
}
